import { Component } from 'vue-property-decorator';
import { GEnum } from '@/constants/enum.defination';
import { IViewMixin } from '@/mixins/IViewMixin';
import { dataTestID, TestButtonAction, TestPrefix } from '@/constants/test.constants';

@Component
export class GPageBase extends IViewMixin {
  $v: any;
  timer: number = 0;
  isRefresh: boolean = true;
  isRunning: boolean = false; // APIアクセス等実行中フラグ

  get INFO_TITLE(): string {
    return this.$t('INFO').toString();
  }
  get INSERT_SUCCESSED_MESSAGE(): string {
    return this.$t('INSERT_SUCCESSED').toString();
  }
  get INSERT_FAILED_MESSAGE(): string {
    return this.$t('INSERT_FAILED').toString();
  }
  get UPDATE_SUCCESSED_MESSAGE(): string {
    return this.$t('UPDATE_SUCCESSED').toString();
  }
  get UPDATE_FAILED_MESSAGE(): string {
    return this.$t('UPDATE_FAILED').toString();
  }
  get DELETE_SUCCESSED_MESSAGE(): string {
    return this.$t('DELETE_SUCCESSED').toString();
  }
  get DELETE_FAILED_MESSAGE(): string {
    return this.$t('DELETE_FAILED').toString();
  }
  get True(): GEnum.RadioLabel {
    return GEnum.RadioLabel.True;
  }
  get False(): GEnum.RadioLabel {
    return GEnum.RadioLabel.False;
  }

  get TestPrefix() {
    return TestPrefix;
  }

  get TestButtonAction() {
    return TestButtonAction;
  }

  dataTestID(prefix: TestPrefix, targetUIName: string, action: TestButtonAction = TestButtonAction.Do) {
    return dataTestID(prefix, targetUIName, action);
  }

  showInsertSuccessed() {
    this.showNotice(GEnum.MessageType.Success, this.INFO_TITLE, this.INSERT_SUCCESSED_MESSAGE);
  }

  showInsertFailed() {
    this.showNotice(GEnum.MessageType.Error, this.INFO_TITLE, this.INSERT_FAILED_MESSAGE);
  }

  showUpdateSuccessed() {
    this.showNotice(GEnum.MessageType.Success, this.INFO_TITLE, this.UPDATE_SUCCESSED_MESSAGE);
  }

  showUpdateFailed() {
    this.showNotice(GEnum.MessageType.Error, this.INFO_TITLE, this.UPDATE_FAILED_MESSAGE);
  }

  showDeleteSuccessed() {
    this.showNotice(GEnum.MessageType.Success, this.INFO_TITLE, this.DELETE_SUCCESSED_MESSAGE);
  }

  showDeleteFailed() {
    this.showNotice(GEnum.MessageType.Error, this.INFO_TITLE, this.DELETE_SUCCESSED_MESSAGE);
  }

  showMessage(msgType: GEnum.MessageType, content: string = '', duration: number = 10) {
    // Only Show Title
    let option = { content: content, duration: duration };
    switch (msgType) {
      case GEnum.MessageType.Info:
        this.$Message.info(option);
        break;
      case GEnum.MessageType.Success:
        this.$Message.success(option);
        break;
      case GEnum.MessageType.Warn:
        this.$Message.warning(option);
        break;
      case GEnum.MessageType.Error:
        this.$Message.error(option);
        break;
    }
  }

  showNotice(msgType: GEnum.MessageType, title: string = '', message: string = '', duration: number = 10) {
    // Only Show Title
    let option = { title: title, desc: message, duration: duration };
    switch (msgType) {
      case GEnum.MessageType.Info:
        this.$Notice.info(option);
        break;
      case GEnum.MessageType.Success:
        this.$Notice.success(option);
        break;
      case GEnum.MessageType.Warn:
        this.$Notice.warning(option);
        break;
      case GEnum.MessageType.Error:
        this.$Notice.error(option);
        break;
    }
  }

  refreshSchoolClassModel(schoolClasses: any, schoolGradeModel: number = 0) {
    let schoolClassVar;
    schoolClasses.some((schoolClass: any) => {
      if (schoolClass.grade == schoolGradeModel) {
        return (schoolClassVar = schoolClass.schoolClassID);
      }
    });
    return schoolClassVar;
  }

  createGradeList(schoolClasses: any): number[] {
    const schoolGrades: any = [];
    schoolClasses.forEach((schoolClass: any) => {
      if (!schoolGrades.includes(schoolClass.grade)) {
        schoolGrades.push(schoolClass.grade);
      }
    });
    return schoolGrades;
  }

  simpleText(text: string, length: number): string {
    let substring = text.substring(0, length);
    if (text.length > length) {
      substring = `${substring}...`;
    }
    return substring;
  }

  isOverLength(text: string, length: number): boolean {
    if (text.length > length) {
      return true;
    }
    return false;
  }

  convertRadioToBoolean(radioLabel: GEnum.RadioLabel): boolean {
    if (radioLabel === GEnum.RadioLabel.True) {
      return true;
    } else {
      return false;
    }
  }

  // 遅延アクション(ボタンの連打対策用)
  lazyAction(f: () => void, second: number = 100) {
    clearTimeout(this.timer);
    this.timer = window.setTimeout(function() {
      f();
    }, second);
  }

  toHankaku(str: string) {
    return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) - 65248);
    });
  }

  // ページローディング実行中(secondはLoadingエフェクトのための遅延時間。waitingの処理が長くなるような場合は0を設定する)
  loadingPage(waiting: () => void, after: () => void, second: number = 1000) {
    this.isRunning = true;
    waiting();
    setTimeout(() => {
      this.isRunning = false;
      after();
    }, second);
  }

  refresh(millisecond: number = 5) {
    this.isRefresh = false;
    setTimeout(() => {
      this.isRefresh = true;
    }, millisecond);
  }

  percent(ratio: number): number {
    return Math.round(ratio * 100);
  }

  /**
   * IView Tableコンポーネントでセル内改行したい場合に使用
   * @param h createElement関数の略名
   * @param rawString 文字列（改行文字\nを含む）
   */
  renderIViewTableCellWithLineBreaks(h: any, rawString: string): any[] {
    const strings: string[] = rawString.split('\n');
    const renderers: any[] = strings.map((element: string) => {
      return h('p', {}, element);
    });
    return h('div', {}, renderers);
  }
}
